<template>
  <Popover>
    <template #title>Invite friends</template>
    <template #content>
      <canvas ref="canvas" class="qr"></canvas>
      <LeeaBtn @mousedown.stop @touchstart.stop @click="share" class="send-btn">Share</LeeaBtn>
      <LeeaBtn @mousedown.stop @touchstart.stop @click="copy">Copy Link</LeeaBtn>
    </template>
  </Popover>
</template>

<script setup lang="ts">
import Popover from '@/components/Popover.vue'
import LeeaBtn from '@/components/LeeaBtn.vue'
import { useUserStore } from '@/stores/user'
import { onMounted, ref } from 'vue'
import QRCode from 'qrcode'
import { analyticsService } from '@/services/analytics.service'

analyticsService.logInviteClicked()

const userStore = useUserStore()

const canvas = ref()

const url = `https://t.me/leea_app_bot/start?startapp=invite=${userStore.user?.id}`

onMounted(() => {
  QRCode.toCanvas(canvas.value, url)
  canvas.value.removeAttribute('style')
})

const share = async () => {
  analyticsService.logInviteShare()
  navigator.share({
    title: 'Join Leea!',
    url
  })
}

const copy = async () => {
  analyticsService.logInviteCopy()
  navigator.clipboard.writeText(url)
}
</script>

<style lang="scss" scoped>
.qr {
  width: 100%;
  position: relative;
  box-shadow: 0 10px 40px rgba(72, 134, 255, 0.2);
  border-radius: 25px;
  margin-bottom: 42px;
}
</style>
